import React, { useState, useEffect } from 'react';
import "@fortawesome/fontawesome-free/js/all";
import './App.scss';
import muiTheme from './theme';
import godown from './assets/images/godown.gif';

import { PacmanLoader } from 'react-spinners';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { Grid, Divider, List, ListItem, ListItemText, ListItemAvatar, Avatar, Breadcrumbs, Typography, Link } from '@material-ui/core';
import MainBody from './Main/MainBody';

const aboutData = [
  {
    item: "Instructor",
    text: "Behrooz Nasihatkon",
    textLink: "https://wp.kntu.ac.ir/nasihatkon",
    icon: "fas fa-chalkboard-teacher",
    imageSrc: "./assets/avatar/behrooz-nasihatkon.jpg",
    hr: true,
  },
  {
    item: "Head Teaching Assistant",
    text: "Soheil Changizi",
    textLink: "https://soheil-changizi.github.io",
    icon: "fas fa-user-graduate",
    imageSrc: "./assets/avatar/soheil-changizi.jpg"
  },
  {
    item: "Teaching Assistant",
    text: "Amirhossein Hassankhani",
    textLink: "https://amirhossein-hassankhani.github.io",
    icon: "fas fa-user-graduate",
    imageSrc: "./assets/avatar/amirhossein-hassankhani.jpg"
  },
  {
    item: "Teaching Assistant",
    text: "Alireza Kavian",
    textLink: "https://alireza-kavian.github.io",
    icon: "fas fa-user-graduate",
    imageSrc: "./assets/avatar/alireza-kavian.jpg"
  },
  {
    item: "Teaching Assistant",
    text: "Taha Samavati",
    textLink: "https://www.linkedin.com/in/taha-samavati-48a886150/",
    icon: "fas fa-user-graduate",
    imageSrc: "./assets/avatar/taha-samavati.jpg"
  },
  {
    item: "Teaching Assistant",
    text: "Alireza Kazemipour",
    textLink: "https://www.linkedin.com/in/alireza-kazemipour-1b7a511a0/",
    icon: "fas fa-user-graduate",
    imageSrc: "./assets/avatar/alireza-kazemipour.jpg"
  },
]

const contactData = [
  {
    item: "Quera",
    text: "Goto Class",
    textLink: "https://quera.ir/overview/add_to_course/course/4860",
    icon: "fab fa-quora",
  },
  {
    item: "Telegram",
    text: "Goto Channel",
    textLink: "https://t.me/joinchat/AAAAAET_uLPV9mYy6gV1ng",
    icon: "fab fa-telegram-plane",
  },
]

const loading = (setLoad) => (
  <div id="loading" onClick={() => setLoad(false)}>
    <div className="animated">
      <PacmanLoader
        size={85}
        color={"#c4b239"}
      />
    </div>
    <div className="text">
      <h1>Computer Vision Course</h1>
      <h2>Spring 2020</h2>
      <h3>Behrooz Nasihatkon</h3>
    </div>
  </div>
)

const about = () => (
  <List className="about">
    {
      (aboutData || []).map((el) => (
        <div key={el.text}>
          <ListItem>
            <ListItemAvatar>
              {
                !el.imageSrc &&
                <Avatar className="avatar">
                  <i className={`${el.icon} fa-lg icon`} />
                </Avatar>
              }
              {
                el.imageSrc &&
                <Avatar className="avatar" src={el.imageSrc} alt={el.text} />
              }
            </ListItemAvatar>
            <ListItemText className="text" primary={<a target="_blank" rel="noopener noreferrer" href={el.textLink}>{el.text}</a>} secondary={el.item} />
          </ListItem>
          {
            el.hr &&
            <Divider className="divider" />
          }
        </div>
      ))
    }
  </List>
);

const contact = () => (
  <List className="contact">
    {
      (contactData || []).map((el) => (
        <ListItem key={el.text}>
          <ListItemAvatar>
            {
              !el.imageSrc &&
              <Avatar className="avatar">
                <i className={`${el.icon} icon`} />
              </Avatar>
            }
            {
              el.imageSrc &&
              <Avatar className="avatar" src={el.imageSrc} alt={el.text} />
            }
          </ListItemAvatar>
          <ListItemText className="text" primary={<a target="_blank" rel="noopener noreferrer" href={el.textLink}>{el.text}</a>} secondary={el.item} />
        </ListItem>
      ))
    }
  </List>
);

const breadCrumb = () => (
  <Breadcrumbs separator="›" aria-label="breadcrumb">
    <Link color="inherit" href="../../">
      All Courses
    </Link>
    <Link color="inherit" href="../">
      CV Course (UG)
    </Link>
    <Typography color="textSecondary">CV Spring 2020</Typography>
  </Breadcrumbs>
)

function App() {
  const [load, setLoad] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoad(false)
    }, 4000);
    window.scrollTo(0, 0);
  }, []);
  return (
    <MuiThemeProvider theme={muiTheme}>
      <div className="App">
        {load && loading(setLoad)}
        <header className="App-header">
          <span id="godown"><img src={godown} alt="\/" /></span>
          <Grid container className="header-wrapper" spacing={2}>
            <Grid className="left" item xs={12} md={5}>
              <div className="bread-crumb">{breadCrumb()}</div>
              <h1>Introduction to computer vision<div>(Spring 2020)</div></h1>
              <div className="contact-parent">
                {contact()}
              </div>
            </Grid>
            <Grid className="right" item xs={12} md={7}>
              {about()}
            </Grid>
          </Grid>
        </header>
        <main id="main" className="App-main"><MainBody /></main>
        <footer className="App-footer">
          <bdi>Behrooz Nasihatkon © 2020 All rights reserved.</bdi>
          <div>Powered by <a href="https://alireza-kavian.github.io">Alireza Kavian</a></div>
        </footer>
      </div>
    </MuiThemeProvider>
  );
}

export default App;
